<template>
  <div>
    <Report
      module="Cliente"
      name="Contato"
      urlGet="/api/v1/crm/report/contact"
      :header="header"
      :filters="filters"
    />
  </div>
</template>

<script>
import Report from "@nixweb/nixloc-ui/src/component/report/Report";

export default {
  name: "ReportContactView",
  components: {
    Report,
  },
  data() {
    return {
      header: [
        {
          title: "Razao Social/Nome",
          field: "customerCompanyName",
          fieldOrderBy: "CustomerCompanyName",
          show: true,
          initialOrderBy: true,
          styleHeader: "width:250px;",
          styleBody:
            "max-width: 240px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Fantasia/Apelido",
          field: "customerTradeName",
          fieldOrderBy: "CustomerTradeName",
          show: true,
          styleHeader: "width:220px;",
          styleBody:
            "max-width: 210px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Contato",
          field: "name",
          fieldOrderBy: "Name",
          show: true,
          styleHeader: "width:220px;",
          styleBody:
            "max-width: 210px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Departamento",
          field: "departament",
          fieldOrderBy: "Departament",
          show: false,
          styleHeader: "width:180px;",
          styleBody:
            "max-width: 170px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Data Nasc.",
          field: "birthDateStr",
          fieldOrderBy: "BirthDate",
          show: false,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Celular",
          field: "mobile",
          fieldOrderBy: "Mobile",
          show: true,
          styleHeader: "width:130px;",
          styleBody: "max-width: 120px;",
        },
        {
          title: "E-mail",
          field: "email",
          fieldOrderBy: "Email",
          show: true,
          styleHeader: "width:220px;",
          styleBody:
            "max-width: 210px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
      ],
      filters: [
        {
          type: "text",
          title: "Razao Social/Nome",
          field: "CustomerCompanyName",
          value: "",
        },
        {
          type: "text",
          title: "Fantasia/Apelido",
          field: "CustomerTradeName",
          value: "",
        },
        {
          type: "text",
          title: "Contato",
          field: "Name",
          value: "",
        },
        {
          type: "text",
          title: "Departamento",
          field: "Departament",
          value: "",
        },
        {
          type: "text",
          title: "Celular",
          field: "Mobile",
          value: "",
        },
        {
          type: "text",
          title: "E-mail",
          field: "Email",
          value: "",
        },
      ],
    };
  },
};
</script>

